import { useParams, Link } from 'react-router-dom'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

interface Product {
  id: number
  name: string
  description: string
  fullDescription: string
  price: string
  image1: string
  image2: string
  stripeLink: string
  features: string[]
}

export default function ProductDetail() {
  const { t } = useTranslation()
  const { id } = useParams()
  const [currentImage, setCurrentImage] = useState(1)

  // Product data - matches the Products component
  const products: Record<number, Product> = {
    1: {
      id: 1,
      name: t('products.product1.name'),
      description: t('products.product1.description'),
      fullDescription: t('products.product1.fullDescription'),
      price: "$15.00",
      image1: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-14.jpg",
      image2: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-18.jpg",
      stripeLink: "https://buy.stripe.com/8x2fZh5tE9dncCP3Yq8Zq02",
      features: t('products.product1.features', { returnObjects: true }) as string[]
    },
    2: {
      id: 2,
      name: t('products.product2.name'),
      description: t('products.product2.description'),
      fullDescription: t('products.product2.fullDescription'),
      price: "$15.00",
      image1: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-15.jpg",
      image2: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-19.jpg",
      stripeLink: "https://buy.stripe.com/8x2fZh5tE9dncCP3Yq8Zq02",
      features: t('products.product2.features', { returnObjects: true }) as string[]
    },
    3: {
      id: 3,
      name: t('products.product3.name'),
      description: t('products.product3.description'),
      fullDescription: t('products.product3.fullDescription'),
      price: "$15.00",
      image1: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-16.jpg",
      image2: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-17.jpg",
      stripeLink: "https://buy.stripe.com/8x2fZh5tE9dncCP3Yq8Zq02",
      features: t('products.product3.features', { returnObjects: true }) as string[]
    },
    4: {
      id: 4,
      name: t('products.product4.name'),
      description: t('products.product4.description'),
      fullDescription: t('products.product4.fullDescription'),
      price: "$15.00",
      image1: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-2.jpg",
      image2: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-1.jpg",
      stripeLink: "https://buy.stripe.com/8x2fZh5tE9dncCP3Yq8Zq02",
      features: t('products.product4.features', { returnObjects: true }) as string[]
    },
    5: {
      id: 5,
      name: t('products.product5.name'),
      description: t('products.product5.description'),
      fullDescription: t('products.product5.fullDescription'),
      price: "$15.00",
      image1: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-12.jpg",
      image2: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-13.jpg",
      stripeLink: "https://buy.stripe.com/8x2fZh5tE9dncCP3Yq8Zq02",
      features: t('products.product5.features', { returnObjects: true }) as string[]
    },
    6: {
      id: 6,
      name: t('products.product6.name'),
      description: t('products.product6.description'),
      fullDescription: t('products.product6.fullDescription'),
      price: "$15.00",
      image1: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-10.jpg",
      image2: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-11.jpg",
      stripeLink: "https://buy.stripe.com/8x2fZh5tE9dncCP3Yq8Zq02",
      features: t('products.product6.features', { returnObjects: true }) as string[]
    },
    7: {
      id: 7,
      name: t('products.product7.name'),
      description: t('products.product7.description'),
      fullDescription: t('products.product7.fullDescription'),
      price: "$15.00",
      image1: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-7.jpg",
      image2: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-8.jpg",
      stripeLink: "https://buy.stripe.com/8x2fZh5tE9dncCP3Yq8Zq02",
      features: t('products.product7.features', { returnObjects: true }) as string[]
    },
    8: {
      id: 8,
      name: t('products.product8.name'),
      description: t('products.product8.description'),
      fullDescription: t('products.product8.fullDescription'),
      price: "$15.00",
      image1: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-6.jpg",
      image2: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-9.jpg",
      stripeLink: "https://buy.stripe.com/8x2fZh5tE9dncCP3Yq8Zq02",
      features: t('products.product8.features', { returnObjects: true }) as string[]
    },
    9: {
      id: 9,
      name: t('products.product9.name'),
      description: t('products.product9.description'),
      fullDescription: t('products.product9.fullDescription'),
      price: "$15.00",
      image1: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-5.jpg",
      image2: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-11.jpg",
      stripeLink: "https://buy.stripe.com/8x2fZh5tE9dncCP3Yq8Zq02",
      features: t('products.product9.features', { returnObjects: true }) as string[]
    }
  }

  const product = products[Number(id)]

  if (!product) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-[#333333] mb-4">{t('products.productDetail.notFound')}</h1>
          <Link to="/" className="text-[#E2725B] hover:underline">{t('products.productDetail.returnHome')}</Link>
        </div>
      </div>
    )
  }

  return (
    <div className="w-full">
      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="container mx-auto px-4 md:px-8 lg:px-12">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <Link to="/" className="hover:text-[#E2725B] transition-colors">{t('nav.home')}</Link>
            <span>/</span>
            <Link to="/#products" className="hover:text-[#E2725B] transition-colors">{t('nav.products')}</Link>
            <span>/</span>
            <span className="text-[#333333] font-medium">{product.name}</span>
          </div>
        </div>
      </div>

      {/* Product Detail Section */}
      <section className="py-12 md:py-16 lg:py-24 bg-white">
        <div className="container mx-auto px-4 md:px-8 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
            {/* Product Images */}
            <div>
              {/* Main Image */}
              <div className="mb-4 rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src={currentImage === 1 ? product.image1 : product.image2}
                  alt={product.name}
                  className="w-full h-[400px] md:h-[500px] lg:h-[600px] object-contain bg-gray-50 p-8"
                />
              </div>
              {/* Thumbnail Images */}
              <div className="flex gap-4">
                <button
                  onClick={() => setCurrentImage(1)}
                  className={`flex-1 rounded-xl overflow-hidden border-4 transition-all ${
                    currentImage === 1 ? 'border-[#E2725B] shadow-lg' : 'border-gray-200 hover:border-[#E2725B]/50'
                  }`}
                >
                  <img
                    src={product.image1}
                    alt={`${product.name} view 1`}
                    className="w-full h-32 object-contain bg-gray-50 p-4"
                  />
                </button>
                <button
                  onClick={() => setCurrentImage(2)}
                  className={`flex-1 rounded-xl overflow-hidden border-4 transition-all ${
                    currentImage === 2 ? 'border-[#E2725B] shadow-lg' : 'border-gray-200 hover:border-[#E2725B]/50'
                  }`}
                >
                  <img
                    src={product.image2}
                    alt={`${product.name} view 2`}
                    className="w-full h-32 object-contain bg-gray-50 p-4"
                  />
                </button>
              </div>
            </div>

            {/* Product Info */}
            <div className="flex flex-col">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#333333] mb-4 font-elegant">
                {product.name}
              </h1>
              
              <p className="text-xl md:text-2xl text-[#E2725B] font-bold mb-6">
                {product.price}
              </p>

              <div className="elegant-divider mb-6"></div>

              <p className="text-lg text-[#333333]/80 mb-6 leading-relaxed">
                {product.fullDescription}
              </p>

              {/* Features */}
              <div className="mb-8">
                <h3 className="text-xl font-bold text-[#333333] mb-4 font-elegant">Key Features</h3>
                <ul className="space-y-3">
                  {product.features.map((feature, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <svg className="w-6 h-6 text-[#4D5D33] flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      <span className="text-[#333333]/80">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Buy Now Button */}
              <a
                href={product.stripeLink}
                className="group w-full min-h-[56px] px-8 py-4 bg-[#4D5D33] hover:bg-[#3d4a28] active:bg-[#3d4a28] text-white text-xl font-bold rounded-xl transition-all duration-300 flex items-center justify-center shadow-xl hover:shadow-2xl hover:scale-[1.02] transform"
              >
                <svg 
                  className="w-6 h-6 mr-3 group-hover:scale-110 transition-transform duration-300" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                </svg>
                <span className="font-extrabold tracking-wide">{t('products.productDetail.addToCart')} - {product.price}</span>
                <svg 
                  className="w-5 h-5 ml-3 group-hover:translate-x-1 transition-transform duration-300" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </a>

              {/* Trust Badges */}
              <div className="mt-8 flex items-center gap-4 flex-wrap">
                <div className="flex items-center gap-2 text-sm text-[#333333]/70">
                  <svg className="w-5 h-5 text-[#4D5D33]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span>{t('products.productDetail.badges.freeShipping')}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-[#333333]/70">
                  <svg className="w-5 h-5 text-[#4D5D33]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span>{t('products.productDetail.badges.organic')}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-[#333333]/70">
                  <svg className="w-5 h-5 text-[#4D5D33]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span>{t('products.productDetail.badges.handcrafted')}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Back to Products */}
      <section className="py-8 bg-gray-50">
        <div className="container mx-auto px-4 md:px-8 lg:px-12 text-center">
          <Link
            to="/#products"
            className="inline-flex items-center gap-2 px-8 py-3 bg-white hover:bg-gray-100 text-[#333333] font-semibold rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border-2 border-gray-200"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            <span>{t('products.productDetail.backToProducts')}</span>
          </Link>
        </div>
      </section>
    </div>
  )
}

